export const getPageDetails = "s/get-page-details-v4";
